import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Module } from 'core/models/course-content.model';

@Component({
  selector: 'app-lesson-header',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './lesson-header.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LessonHeader {
  @Input({ required: true }) icon!: string;
  @Input({ required: true }) iconColor!: string;
  @Input({ required: true }) title!: string;
  @Input() subtitle = '';
  @Input() align: 'center' | 'start' = 'center';
  @Input() wrapText = false;
  @Input() module?: Module | null;
  @Input() showModuleInfo = false;
  @Input() additionalClasses = '';

  protected get combinedClasses(): string {
    const baseClasses =
      'flex items-center px-4 py-3 bg-white border-b border-gray-200';
    return this.additionalClasses
      ? `${baseClasses} ${this.additionalClasses}`
      : baseClasses;
  }
}
